<template>
  <v-container fluid class="px-0">
    <div class="bankaccount-page">
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-card class="folder-card ma-1">
            <v-card-text class="pa-5 pt-0">
              <v-row justify="center" style="margin-top: 5px;">
                <v-col cols="12" md="12">
                  <v-row>
                    <v-col md="11">
                      <p class="text-h5">{{ initvalue.accountcode }}</p>
                    </v-col>
                    <v-col md="1" align="right">
                      <v-btn
                      class="button-shadow"
                      color="primary"
                     @click="Done"
                      >
                        Done
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row class="no-gutters" style="margin-left: 5px;">
                <v-col cols="12" md="10">
                  <v-row class="no-gutters">
                    <v-col cols="12" md="4">
                      <table style="width: 100%;">
                        <tr>
                          <td><span style="font-weight: 700;">Name</span></td>
                          <td>{{ initvalue.accountname }}</td>
                        </tr>
                        <tr>
                          <td><span style="font-weight: 700;">Open Date</span></td>
                          <td>{{ new Date(initvalue.accountstartdate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                        <tr v-if="initvalue.accountenddate!=null">
                          <td><span style="font-weight: 700;">Close Date</span></td>
                          <td>{{ new Date(initvalue.accountenddate).toLocaleString("en-SG", {year: "numeric", month: "numeric",day: "numeric"}) }}</td>
                        </tr>
                      </table>
                    </v-col>
                    <v-col cols="12" md="4">

                    </v-col>
                    <v-col cols="12" md="4">

                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12" cols="12" class="pt-0 pt-sm-3">
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-0">

                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                      ref="filesTab"
                      class="text-capitalize font-weight-regular"
                      :key="1"
                      :href="'#tab-statements'"
                    >
                      Statements
                    </v-tab>
                    <v-tab-item
                      :key="1"
                      :value="'tab-statements'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row
                        justify-xl="space-around"
                        justify="start"
                        class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5"
                      >
                        <v-col cols="12" md="12" sm="12">
                          <v-data-table
                            sort-by="statementdate"
                            sort-desc
                            :headers="header_statements"
                            :items="bankstatements"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.statementfile="{ item }">
                              <a
                                v-if="item.statementfile!==''"
                                :href="item.statementfile"
                                style="text-decoration: none !important"
                              >
                                <v-icon size="50" color="primary">
                                  mdi-file-pdf-box
                                </v-icon></a
                              >
                            </template>
                            <template v-slot:item.statementbalance="{ item }">
                              {{ item.statementbalance!=null ? item.statementbalance.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '' }}
                            </template>
                            <template v-slot:item.statementdate="{ item }">
                              {{
                                new Date(item.statementdate).toLocaleString(
                                  "en-SG",
                                  {
                                    year: "numeric",
                                    month: "numeric",
                                    day: "numeric",
                                  }
                                )
                              }}
                            </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="previewFile(item)"
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                          </v-data-table>
                        </v-col>
                      </v-row>
                    </v-tab-item>
                    <v-tab-item
                      :key="3"
                      :value="'tab-images'"
                      class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-container
                        class="fill-height"
                        fluid
                        style="min-height: 434px"
                      >
                        <v-fade-transition mode="out-in">
                          <v-row>
                            <v-col cols="4">
                              <v-card
                              v-for="image in images" :key="image._id"
                              :ripple="{class: 'ripple-color' }"
                              @click="clickImage(image)"
                              >
                                <v-img
                                  :src="image.imageurl"
                                  height="300"
                                  cover
                                  class="bg-grey-lighten-4"
                                  
                                ></v-img>
                                <v-card-title class="text-h8">
                                  {{ image.imagename }}
                                </v-card-title>
                              </v-card>
                            </v-col>
                          </v-row>
                        </v-fade-transition>
                      </v-container>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <div class="text-center">
    <v-dialog
      v-model="showImageDialog"
      width="500px"
    >
      <v-card class="mx-1 mb-1">
        <v-card-text>
          
          <v-row v-if="image">
            <v-col cols="12">
              <v-img
              max-width="500px"
              cover
              :src="image.imageurl"
            ></v-img> 
            </v-col>

          </v-row>
      
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="showImageDialog = false"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  </v-container>
</template>

<script>
import config from "@/config";
import { mapState, mapActions } from 'vuex'

export default {
  name: "Profile",

  data() {
    return {
      config,
      initvalue: {},
      transactions: [],
      bankstatements: [],
      images: [],
      showImageDialog: false,
      image: null,
      header_statements: [
        { text: "File", value: "statementfile", width: '8%' },
        { text: "Date", value: "statementdate", width: '10%' },
        { text: "Name", value: "statementname" },
        { text: "Balance", value: "statementbalance", width: '20%', align:'left'},
        { text: "Actions", value: "actions", sortable: false, width: '10%'},
      ],

      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
    };
  },
  computed: {
    ...mapState('Account', ['accounts']),
    ...mapState('Employee', ['employees']),
  },
  methods: {
    ...mapActions('Account', ["getAccountsRequest"]),
    ...mapActions('Employee', ["getEmployeesRequest"]),
    ...mapActions("File", ["getBillFiles"]),
    clickImage(image){
      console.log(image.imageurl);
      this.image = image;
      this.showImageDialog = true;
    },
    previewFile(item){
      let params = Object.assign({}, this.initvalue);
      params.fileurl = item.statementfile;
      params.isFromBankAccount = true;
      this.$router.push({ name: "FilePreview", params: params })
    },
    Done(){
      this.$router.push({ name: 'BankAccountList' });
    },
  },
  async created() {
    this.initvalue = this.$route.params;    
    if (!this.initvalue._id) this.$router.push({ name: "BankAccountList" });
    this.transactions = this.initvalue.transactions;
    this.bankstatements = this.initvalue.statements;
    this.images = this.initvalue.images;
    if(this.accounts.length==0) await this.getAccountsRequest();
    if(this.employees.length==0) await this.getEmployeesRequest();
    if(this.initvalue.isFromFiles==true) {this.$refs.filesTab.$el.click()}
  },
};
</script>

<style src="./View.scss" lang="scss"/>
